import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_PROCESS_TASK } from './get-process-task.hook';
import { GET_PROCESS_TASKS_FOR_TABLE } from './get-process-tasks.hook';
import { GET_PROCESS_BY_ID } from '../processes/get-process-by-id.hook';

export const DELETE_PROCESS_TASK = gql`
  mutation deleteProcessTask($taskId: ObjectId!) {
    deleteProcessTask(taskId: $taskId) {
      _id
    }
  }
`;

export const useDeleteProcessTask = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('processBuilder');
  const [deleteProcessTask] = useMutation(DELETE_PROCESS_TASK, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteProcessTask?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('tasks.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('settings:userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [GET_PROCESS_TASKS_FOR_TABLE, GET_PROCESS_TASK, GET_PROCESS_BY_ID],
  });

  return deleteProcessTask;
};
